import type { FaireProductEntity } from "../../entity_types/product";

export const p_d5gzuj2767: FaireProductEntity = {
  token: "p_d5gzuj2767",
  type: "product",
  name: "bouquet notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/2ba195fff3831489bebb80487bf205d63f94d1592bf727395f8004847dd3bebd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bcdf8c25e4e848f1d1106bd7e173ffb6cc78ccbc07a44a32665ce4fe82f8995.jpeg",
  ],
  priceDollars: 8,
  description:
    "The bouquet notecards are blank on the inside with a charming bouquet watercolor illustration on the front. They bring a touch of cheer to your thank you notes, get well wishes, and more.\n\n• set of eight (or single) folded cards with envelopes\n• blank inside\n• 5.5 inch x 4.25 inch\n• printed on 120lb superfine paper\n• original artwork by Emily Lex",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:52.210Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
